// Živé překlady titulků (doplněk News in your language). Server po dokončení překladu pošle do kanálu
// translations:<jazyk> {source, id, text} (moodix/ai/translate.py); socket.js z toho udělá událost `mx:translation`.
// Prvky s data-tr="zdroj:id" (feed, Top 5) dostanou překlad bez znovunačtení, notifikace na něj krátce počká.
const cache = new Map();
const waiters = new Map();

export const contentLang = () => document.getElementById('mx-live')?.dataset.contentLang || 'en';

function apply(root, key, text) {
  root.querySelectorAll(`[data-tr="${CSS.escape(key)}"]`).forEach((el) => {
    if (el.textContent.trim() === text) return;
    if (!el.title) el.title = el.textContent.trim();  // originál zůstane v bublině
    el.textContent = text;
  });
}

export function initTranslations() {
  window.addEventListener('mx:translation', (e) => {
    const { source, id, text } = e.detail || {};
    if (!source || !id || !text) return;
    const key = `${source}:${id}`;
    cache.set(key, text);
    (waiters.get(key) || []).forEach((done) => done(text));
    waiters.delete(key);
    apply(document, key, text);
  });
  // Obnovené části stránky (HTMX) mohly přijít dřív, než překlad doběhl
  document.body.addEventListener('htmx:afterSwap', (e) => applyCached(e.target?.isConnected ? e.target : document));
}

/** Už doručený překlad titulku („zdroj:id“), jinak null. */
export const cachedTranslation = (key) => cache.get(key) || null;

/** Doplní už známé překlady do nově vložené části stránky (živé obnovení v live.js). */
export function applyCached(root) {
  cache.forEach((text, key) => apply(root, key, text));
}

/** Překlad titulku, nejdéle `ms` ms; v angličtině nebo po vypršení null (zobrazí se originál). */
export function waitTranslation(key, ms = 3000) {
  if (contentLang() === 'en') return Promise.resolve(null);
  if (cache.has(key)) return Promise.resolve(cache.get(key));
  return new Promise((resolve) => {
    const done = (value) => { clearTimeout(timer); resolve(value); };
    const timer = setTimeout(() => done(null), ms);
    waiters.set(key, [...(waiters.get(key) || []), done]);
  });
}
